<template>
    <div class="newsCardPhone">
        <div class="newsCardList">
            <Row>
                <Col span="24" :key="item.id" v-for="item in contentList">
                    <div class="newsCardList-box" @click="clickDetail(item.id)">
                        <div class="box-imgL">
                            <img :src="item.imageUrl"/>
                        </div>
                        <div class="box-msgR">
                            <div class="news-titP">
                                {{item.title}}
                            </div>
                            <div class="time"> {{item.releaseTimeStr}}</div>
                        </div>
                    </div>
                </Col>
                <!-- <Col span="8">
                    <div class="newsCardList-box">
                        <div class="box-imgL">
                            <img src="../assets/images/web/newsCardpic2.jpg"/>
                        </div>
                        <div class="box-msgR">
                            <div class="news-titP">
                                喜讯 盛大天地·源创谷成
                                功入选2021-2022年度上
                                海市级文化创意产业园区
                            </div>
                            <div class="time">2022-02-04</div>
                        </div>
                    </div>
                </Col>
                <Col span="8">
                    <div class="newsCardList-box">
                        <div class="box-imgL">
                            <img src="../assets/images/web/newsCardpic1.jpg"/>
                        </div>
                        <div class="box-msgR">
                            <div class="news-titP">
                                喜讯 盛大天地·源创谷成
                                功入选2021-2022年度上
                                海市级文化创意产业园区
                            </div>
                            <div class="time">2022-02-04</div>
                        </div>
                    </div>
                </Col> -->
            </Row>
        </div>
    </div>
</template>

<script>
    export default {
        name: "NewsCard",
        props: {
            // onSelected: {
            //     type: Function
            // },
            nodeId:Number,
        },
        data(){
            return{
                loading:false,
                contentList:[],
            }
        },
        methods:{
            geContents(nodeId) {
                this.loading = true;
                this.$http
                    .post('/api/services/app/CommonWeb/SearchContents', {
                        maxResultCount: 3,
                        skipCount: 0,
                        nodeId:nodeId
                        
                    })
                    .then((res) => {
                        console.log(res);
                        this.contentList = res.data.result.items;
                    })
                    .finally(() => {
                        this.loading = false;
                    });
            },
            clickDetail(id){
                this.$router.push({path: '/newsDetail',query:{id:id}});
            },
        },
        mounted(){
            this.geContents(this.nodeId);
        },
        watch: {
            nodeId: {
                deep: true,
                handler: function (value) {
                    this.geContents(value);
                }
            },
        }

    }
</script>

<style lang="less">
.newsCardPhone{
    .newsCardList{
        margin:0 -15px;
        .newsCardList-box{
            border: 1px solid #E3E3E3;
            box-shadow: 0px 0px 1px 0px rgba(151, 151, 151, 0.5);
            background-color: #fff;
            display: flex;
            flex-flow: row;
            margin:0 15px 15px 0;
            .box-imgL{
                width:170px;
                height: 130px;
                img{
                    width:170px;
                    height: 130px;
                }
            }
            .box-msgR{
                padding:20px 20px 10px 20px;
                .news-titP{
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                    font-size:14px;
                    height: 64px;
                    color:#333;
                }
                .time{
                    padding-top:10px;
                    font-size:12px;
                    color:#666;
                }
            }
        }
        .newsCardList-box:hover{
            box-shadow: 0px 5px 10px 0px rgba(18, 59, 89, 0.19);
        }
    }
}
</style>